module.exports = __webpack_public_path__ + "img/微信图片_20251029163310_21_62.894f9bf1.jpg";